export const LETTER_ISSUES_MARKER_START = '<!--CTMS_OPEN_ISSUES_TABLE_START-->';
export const LETTER_ISSUES_MARKER_END = '<!--CTMS_OPEN_ISSUES_TABLE_END-->';
export const REPORT_CREATED_MARKER_START = '<!--CTMS_REPORT_CREATED_BY_START-->';
export const REPORT_CREATED_MARKER_END = '<!--CTMS_REPORT_CREATED_BY_END-->';

export function stripLetterIssuesBlock(html) {
  if (!html) return '';
  const startIdx = html.indexOf(LETTER_ISSUES_MARKER_START);
  if (startIdx === -1) return html;
  const endIdx = html.indexOf(LETTER_ISSUES_MARKER_END, startIdx);
  if (endIdx === -1) return html.slice(0, startIdx).trimEnd();
  return (html.slice(0, startIdx) + html.slice(endIdx + LETTER_ISSUES_MARKER_END.length)).trimEnd();
}

export function extractLetterIssuesBlock(html) {
  if (!html) return '';
  const startIdx = html.indexOf(LETTER_ISSUES_MARKER_START);
  if (startIdx === -1) return '';
  const endIdx = html.indexOf(LETTER_ISSUES_MARKER_END, startIdx);
  if (endIdx === -1) return '';
  return html.slice(startIdx + LETTER_ISSUES_MARKER_START.length, endIdx).trim();
}

export function stripReportCreatedByBlock(html) {
  if (!html) return '';
  const startIdx = html.indexOf(REPORT_CREATED_MARKER_START);
  if (startIdx === -1) return html;
  const endIdx = html.indexOf(REPORT_CREATED_MARKER_END, startIdx);
  if (endIdx === -1) return html.slice(0, startIdx).trimEnd();
  return (html.slice(0, startIdx) + html.slice(endIdx + REPORT_CREATED_MARKER_END.length)).trimEnd();
}

export function extractReportCreatedByBlock(html) {
  if (!html) return '';
  const startIdx = html.indexOf(REPORT_CREATED_MARKER_START);
  if (startIdx === -1) return '';
  const endIdx = html.indexOf(REPORT_CREATED_MARKER_END, startIdx);
  if (endIdx === -1) return '';
  return html.slice(startIdx, endIdx + REPORT_CREATED_MARKER_END.length);
}

export function parseVisitsSummaryFromIssuesHtml(issuesHtml) {
  if (!issuesHtml) return '';
  // New format (matches Preview) and legacy email wording both supported.
  const match = issuesHtml.match(
    /(?:Selected visits|Visits included for the issues below):<\/strong>\s*([^<]+)/i
  );
  return match ? match[1].trim() : '';
}

export function splitLetterContent(header, body, footer) {
  const rawBody = body ?? '';
  const rawFooter = footer ?? '';
  const issuesHtml = extractLetterIssuesBlock(rawBody);
  // Additive: sign-off may be in body (legacy) or footer (matches Preview order).
  const reportCreatedByHtml =
    extractReportCreatedByBlock(rawBody) || extractReportCreatedByBlock(rawFooter);
  const bodyHtml = stripReportCreatedByBlock(stripLetterIssuesBlock(rawBody));
  const footerText = stripReportCreatedByBlock(rawFooter);
  return {
    headerText: header ?? '',
    bodyHtml,
    issuesHtml,
    reportCreatedByHtml,
    footerText,
    visitsSummaryFromStored: parseVisitsSummaryFromIssuesHtml(issuesHtml),
  };
}

export function getPreviewTitle(letterKind) {
  const kind = normalizeLetterKind(letterKind);
  if (kind === 'piconfirmation') return 'PI Confirmation Letter Preview';
  return kind === 'followup'
    ? 'Generate Follow-Up Letter Preview'
    : 'Generate Visit Letter Preview';
}

export function normalizeLetterKind(letterKind) {
  const k = (letterKind || 'visit').trim().toLowerCase();
  if (k === 'followup' || k === 'follow-up') return 'followup';
  if (k === 'piconfirmation' || k === 'pi-confirmation') return 'piconfirmation';
  return 'visit';
}
